import type { ShareClass } from "@/types";

export default function (sc: ShareClass) {
	return `${sc.letter} ${sc.type} ${sc.currency}${sc.isHedged ? " Hedged" : ""}`;
}
